module.exports = "https://coursera_assets.s3.amazonaws.com/images/5205e0ee0fb7aa454eaaa6b10ac259d6.png";